export const headingData = [
    {
      code: "<h1>",
      text: "All HTML Headings,",
    },
    {
      code: "<h6> ",
      text: " through",
    },
    {
      text: "are available.",
    },
  ];

  export const fontWeightData = [
    {
      code: "f-w-*",
      text: "Using",
    },
    {
      text: " class, you can change the font weight.",
    },
  ];

  export const listingData = [
    {
      code: "<ul>",
      text: "All Typography List :-",
    },
    {
      code: "<ol>",
      text: ",",
    },
    {
      code: "<dl>",
      text: "&",
    },
  ];

export const unOrderData = ["One who does something not professionally but for pleasure", "A person who knows everything", "A handwriting that cannot be read", "One who looks on the bright side of things", "A sound that cannot be heard", "The study of ancient writing and scriptures", "The study of rocks and soil", "creates more sophisticated capabilities for a web page to use coding language.", "Maintaining contact and communicating clearly are also essential. possess abilities for a designer"];

export const orderListData = [
    {
      dt: "The way to get started is to quit talking and begin doing.",
      dd: "-Walt Disney",
    },
    {
      dt: "Life is what happens when you're busy making other plans.",
      dd: "-John Lennon",
    },
    {
      dt: "Whoever is happy will make others happy too. ",
      dd: "-Anne Frank",
    },
    {
      dt: "Life is either a daring adventure or nothing at all.",
      dd: "-Helen Keller",
    },
    {
      dt: "The purpose of our lives is to be happy.",
      dd: "-Dalai Lama",
    },
  ];

  export const displayData = [
    {
      text: "Traditional heading elements are designed to work best in the meat of your page content. When you need a heading to stand out, consider using a",
      mark: "display heading",
    },
    {
      text: " a larger, slightly more opinionated heading style.",
    },
  ];

  export const inlineData = [
    {
      text: "Styling for common inline HTML5 elements.",
    },
  ];

  export const textColorData = [
    {
      code: "txt-*",
      text: "You can Give text color by using ",
    },
    {
      text: " class",
    },
  ];
  
  export const textDataColor = [
    {
      title: "Secondary",
      code: "txt-secondary",
    },
    {
      title: "Success",
      code: "text-success",
    },
    {
      title: "Info",
      code: "txt-info",
    },
    {
      title: "Warning",
      code: "txt-warning",
    },
    {
      title: "Danger",
      code: "txt-danger",
    },
    {
      title: "Dark",
      code: "txt-dark",
    },
    {
      title: "Primary",
      code: "txt-primary",
    },
  ];

  export const blockquoteData = [
    {
      code: "<blockquote>",
      text: "The ",
    },
    {
      text: " tag specifies a section that is quoted from another source.",
    },
  ];
  
  export const blockquote = [
    {
      text: "In this life we cannot do great things. We can only do small things with great love.",
      name: "Mother Teresa",
      className: "center",
      color:"secondary",
    },
    {
      text: "Live in the sunshine, swim the sea, drink the wild air.",
      name: "Ralph Waldo Emerson",
      className: "end",
      color:"warning",
    },
  ];